import { useDesignTokens } from '@sas/nova-commons/theme';
import { useCallback } from 'react';
export function useBusyStateAnimationTokens() {
    const dt = useDesignTokens();
    return useCallback(() => ({
        bg: dt.c.primary,
        'animation-start': dt.c.primary,
        'animation-end': dt.c.n3,
    }), [dt]);
}
